export default "__VITE_ASSET__DAlLyL$i__"